<template>
    <module-card>
        <p>
            OK, now let’s talk about how we use our body to communicate what we want. From this next list, select what <strong>YOU</strong> think are the top three tips you’d tell P to remember for good and effective and
            <strong>body communication</strong> so that he gets what he wants.
        </p>
        <p>
            <strong
                >Reorder the tips below, starting with the one that is most important for YOU. In order to re-order the tips, click on the tip you want to move, then click on the space you would like to move it to. Once you’ve got them in
                your preferred order, tap Next.</strong
            >
        </p>

        <transition-group name="sort-list" tag="div">
            <v-row
                align="center"
                v-for="(step, index) in shuffledStepsOrder"
                :key="step.order"
                class="grey lighten-3 px-2 ml-3 mb-1"
                :class="{ info: index === selectedIndex, available: isAvailable(step.order, index) }"
                @click="click(step.order, index)"
            >
                <v-col cols="1" class="ordinal" :class="{ 'info--text': isAvailable(step.order, index) }">
                    <div>{{ index + 1 }}</div>
                </v-col>
                <v-col>{{ step.step }}</v-col>
            </v-row>
        </transition-group>
    </module-card>
</template>

<script>
    import { shuffle } from 'lodash';

    export default {
        data() {
            return {
                steps: [
                    {
                        order: 1,
                        step: 'Body positioning (facing versus NOT facing someone)'
                    },
                    {
                        order: 2,
                        step: 'Body posture (standing or sitting up straight versus slumping over)'
                    },
                    {
                        order: 3,
                        step: 'Active listening (eye contact, nodding, smiling when appropriate versus inactive listening – not paying attention, texting, falling asleep)'
                    },
                    {
                        order: 4,
                        step: 'Neutral and movement (being aware of aggressive hand, arm, neck movement – these might close off communication if they are seen as intimidating.)'
                    },
                    {
                        order: 5,
                        step: 'Other gestures (NOT sighing deeply when you get annoyed, rolling eyes, winking or blinking – which can be signs of frustration).'
                    },
                    {
                        order: 6,
                        step: 'Eye contact with who you’re talking or listening to (looking versus NOT looking at someone)'
                    }
                ],
                selectedIndex: null,
                shuffledStepsOrder: []
            };
        },
        mounted() {
            this.shuffledStepsOrder = shuffle(this.steps);
        },
        methods: {
            isAvailable(key, index) {
                return this.selectedIndex !== null && this.selectedIndex !== index;
            },
            click(key, index) {
                if (this.selectedIndex !== null) {
                    const a = this.shuffledStepsOrder[this.selectedIndex];
                    const b = this.shuffledStepsOrder[index];
                    this.shuffledStepsOrder.splice(this.selectedIndex, 1, b);
                    this.shuffledStepsOrder.splice(index, 1, a);

                    this.selectedIndex = null;
                } else {
                    this.selectedIndex = index;
                }
            }
        }
    };
</script>

<style scoped>
    .ordinal {
        margin-left: -3em;
        padding-right: 2em;
        width: 2em;
    }
    .ordinal div {
        font-weight: bold;
        width: 20px;
        margin-left: -2px;
        text-align: center;
    }
    .available {
        box-shadow: 0 0 0 1px inset #0091ff;
        opacity: 0.75;
    }
    .sort-list-move {
        transition: transform 1s;
    }
</style>
